import React from 'react';

export default class ProgressIndicator extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("ProgressIndicator", this.props)
		return (
			<div className="ProgressIndicator">
				<div className="w-full bg-gray-200 h-3 mb-4 rounded-md">
					<div
						className="bg-green-500 h-3 rounded-md"
						style={{ width: `${this.props.percentComplete}%` }}
					/>
				</div>
			</div>
		);
	}
}
